// Shared time-slot arithmetic used by both the calendar (time-first) and
// provider-availability steps of the booking flow.

export const parseTime = (timeStr: string): number => {
  const [hour, minute] = timeStr.split(":").map(Number);
  return hour * 60 + minute;
};

export const formatTime = (minutes: number): string => {
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const roundToNearestInterval = (
  minutes: number,
  interval: number
): number => {
  return Math.round(minutes / interval) * interval;
};

export const formatTimeToNearestInterval = (
  timeStr: string,
  interval: number
): string => {
  const totalMinutes = parseTime(timeStr);
  const roundedMinutes = roundToNearestInterval(totalMinutes, interval);
  return formatTime(roundedMinutes);
};

export const generateTimeSlots = (
  timeStart: string,
  timeEnd: string,
  interval: number
): string[] => {
  const slots: string[] = [];
  const startMinutes = parseTime(timeStart);
  const endMinutes = parseTime(timeEnd);

  for (
    let minutes = startMinutes;
    minutes + interval <= endMinutes;
    minutes += interval
  ) {
    const slotStart = formatTime(minutes);
    const slotEnd = formatTime(minutes + interval);
    slots.push(`${slotStart} - ${slotEnd}`);
  }

  return slots;
};
